module.exports = __webpack_public_path__ + "img/knu.9e2981f0.svg";